import PortalIdParser from 'PortalIdParser';
import { createSlice } from '@reduxjs/toolkit';
import { getIsPortal53 } from '../widget-data/operators/getIsPortal53';
import { SPOTLIGHT } from 'conversations-internal-schema/widget-data/constants/launcherTypes';
import { getGates, getLauncherType } from 'conversations-internal-schema/widget-data/operators/widgetDataGetters';
import { SPOTLIGHT_FORM_FACTOR_GATE } from '../widget-data/constants/gates';
import { receivedWidgetData } from '../actions/bootstrapWidget';
const COMPACT_WIDGET_SIZE = {
  width: 416,
  height: 530
};
const STANDARD_WIDGET_SIZE = {
  width: 416,
  height: 700
};
const SPOTLIGHT_WIDGET_SIZE = {
  width: 700,
  height: 600
};
const getUsesCompactWidget = () => getIsPortal53() || PortalIdParser.get() === 44300118;
const initialState = {
  size: STANDARD_WIDGET_SIZE,
  usesCompactWidget: getUsesCompactWidget(),
  preferredSize: null
};
const getStandardWidgetSize = usesCompactWidget => usesCompactWidget ? COMPACT_WIDGET_SIZE : STANDARD_WIDGET_SIZE;
const widgetSizeSlice = createSlice({
  name: 'widgetSize',
  initialState,
  reducers: {
    setWidgetSize(state, action) {
      state.size = action.payload;
    },
    setPreferredWidgetSize(state, action) {
      state.preferredSize = action.payload;
    },
    setStandardWidgetSize(state) {
      state.size = getStandardWidgetSize(state.usesCompactWidget);
    }
  },
  extraReducers: builder => {
    builder.addCase(receivedWidgetData, (state, action) => {
      const launcherType = getLauncherType(action.payload);
      const gates = getGates(action.payload);
      const isSpotlight = !!(gates !== null && gates !== void 0 && gates[SPOTLIGHT_FORM_FACTOR_GATE]) && launcherType === SPOTLIGHT;
      state.size = isSpotlight ? SPOTLIGHT_WIDGET_SIZE : getStandardWidgetSize(state.usesCompactWidget);
    });
  }
});
export const {
  setWidgetSize,
  setStandardWidgetSize,
  setPreferredWidgetSize
} = widgetSizeSlice.actions;
export default widgetSizeSlice.reducer;